import { message } from "antd";

// Aviso visible para errores de acciones del usuario (en lugar de fallar en silencio).
// Un mismo texto no se repite mientras siga en pantalla.
export const avisarError = (texto) => message.error({ content: texto, key: texto });
